class TeamCarousel {
    constructor() {
        this.currentIndex = 1;
        this.totalItems = 7;
        this.interval = null;
        this.isPaused = false;
        this.init();
    }

    init() {
        this.setupEventListeners();
        this.startAutoPlay();
    }

    setupEventListeners() {
        // Click events for thumbnails
        for (let i = 1; i <= this.totalItems; i++) {
            const thumbnail = document.getElementById(`show${i}`);
            if (thumbnail) {
                thumbnail.addEventListener('click', () => {
                    this.showSlide(i);
                    this.pauseAutoPlay();
                });

                // Hover events
                thumbnail.addEventListener('mouseenter', () => this.pauseAutoPlay());
                thumbnail.addEventListener('mouseleave', () => this.resumeAutoPlay());
            }
        }

        // Hover events for content area
        const contentWrapper = document.querySelector('.career-content-wrapper');
        const imageWrapper = document.querySelector('.career-image');

        [contentWrapper, imageWrapper].forEach(element => {
            if (element) {
                element.addEventListener('mouseenter', () => this.pauseAutoPlay());
                element.addEventListener('mouseleave', () => this.resumeAutoPlay());
            }
        });
    }

    showSlide(index) {
        // Hide all content and images
        for (let i = 1; i <= this.totalItems; i++) {
            const content = document.getElementById(`content${i}`);
            const image = document.getElementById(`image${i}`);
            const thumbnail = document.getElementById(`show${i}`);

            if (content) content.style.display = 'none';
            if (image) image.style.display = 'none';
            if (thumbnail) thumbnail.classList.remove('active');
        }

        // Show current content and image
        const currentContent = document.getElementById(`content${index}`);
        const currentImage = document.getElementById(`image${index}`);
        const currentThumbnail = document.getElementById(`show${index}`);

        if (currentContent) currentContent.style.display = 'block';
        if (currentImage) currentImage.style.display = 'block';
        if (currentThumbnail) currentThumbnail.classList.add('active');

        // Update slide bar position
        this.updateSlideBar(index);

        this.currentIndex = index;
    }

    updateSlideBar(index) {
        const slideBar = document.querySelector('.slideBar');
        if (slideBar) {
            const positions = ['0%', '14.28%', '28.56%', '42.84%', '57.12%', '71.4%', '85.68%'];
            slideBar.style.top = positions[index - 1];
        }
    }

    nextSlide() {
        const nextIndex = this.currentIndex >= this.totalItems ? 1 : this.currentIndex + 1;
        this.showSlide(nextIndex);
    }

    startAutoPlay() {
        this.interval = setInterval(() => {
            if (!this.isPaused) {
                this.nextSlide();
            }
        }, 4000);
    }

    pauseAutoPlay() {
        this.isPaused = true;
    }

    resumeAutoPlay() {
        this.isPaused = false;
    }

    stopAutoPlay() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}

// Initialize carousel when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new TeamCarousel();
});
